import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent, V2DialogFrameComponent, V2DialogFooterComponent } from '@coin/shared/core/ui-storybook';
import { SimpleLangSwitchComponent } from '@coin/shared/core/feature-legacy-components';

// TODO:
// To be standalone, requires standalone:
// - SimpleLangSwitchComponent
@Component({
  selector: 'customer-app-equity-legal-disclaimer',
  templateUrl: './equity-legal-disclaimer.component.html',
  styleUrls: ['./equity-legal-disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    V2DialogFrameComponent,
    V2DialogFooterComponent,
    V2ButtonComponent,
    SimpleLangSwitchComponent,
    TranslatePipe
  ]
})
export class EquityLegalDisclaimerComponent {
  private readonly dialogRef = inject<MatDialogRef<EquityLegalDisclaimerComponent>>(MatDialogRef);
  private readonly translateService = inject(TranslateService);

  getTranslation(translateString): string | SafeHtml {
    return this.translateService.instant(translateString);
  }

  static openDialog(dialog: MatDialog): MatDialogRef<EquityLegalDisclaimerComponent> {
    return dialog.open<EquityLegalDisclaimerComponent, undefined, boolean>(EquityLegalDisclaimerComponent, {
      maxWidth: '880px',
      width: '100%',
      minWidth: '375px',
      height: '80vh',
      disableClose: true
    });
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  close(): void {
    this.dialogRef.close();
  }
}
